module.exports = __webpack_public_path__ + "static/media/clap.6d3ac053.png";